import type { UserProfile, UserOrder } from '@/types/';

export const useUserStore = defineStore('userStore', () => {
  const userProfile = ref<UserProfile>();
  const userOrders = ref<UserOrder[]>();
  const { isUserAuthorized } = storeToRefs(useAuthStore());

  async function getUserProfile() {
    if (isUserAuthorized.value) {
      const { userAccessToken } = storeToRefs(useAuthStore());
      const resp = await $fetch(`/api/auth/user-info?token=${userAccessToken.value}`);
      if ('error' in resp) {
        console.error('Error fetching user profile:', (resp as { error: unknown }).error);
      } else {
        userProfile.value = resp as UserProfile;
        return userProfile.value;
      }
    }

    return null;
  }

  async function getUserOrders() {
    if (userProfile.value) {
      const resp = await $fetch('/api/user-orders?userId=' + userProfile.value.sub);

      if ('error' in resp) {
        console.error('Error fetching user orders:', (resp as { error: unknown }).error);
      } else {
        userOrders.value = resp as UserOrder[];
        return userOrders.value;
      }
    }
  }

  return {
    userProfile,
    getUserProfile,
    userOrders,
    getUserOrders,
  };
});
